import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwhw4edtj9: FaireProductEntity = {
  token: "p_bwhw4edtj9",
  type: "product",
  name: "Corduroy Tote Bag - Large Soft Shoulder Bag for Daily, Shopping & Casual Use",
  brandToken: "b_8p6hzrhexg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c0beff8d0b0268ef019cb9444d8a068fe8749d0913fa83f89119074399364d7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/acc9ab3f45c138ba28f98cd0a2e287c81298d3c296c053437c209409cfac8bfb.jpeg",
    "https://cdn.faire.com/fastly/94546b1688fe92f2d770571348757363210188552c22f62dcabe5c06facbf25c.jpeg",
    "https://cdn.faire.com/fastly/12e92967089f373cdc4c9ec8ab5b932a211d0a3806395e7bc1100ae15a4a7e7d.jpeg",
    "https://cdn.faire.com/fastly/e72f8c36bd4223aad78edd28daee91174436ca0f737e10434718a8f439ba36f5.jpeg",
    "https://cdn.faire.com/fastly/243c718f497aec4743107e12c2baae119229ffabaac4cb8a31a0603579c31656.jpeg",
    "https://cdn.faire.com/fastly/953fd36b52dc7e71af727d37eee2b833364346739c19fa9e60365c4db3b43482.jpeg",
    "https://cdn.faire.com/fastly/b2bd5fff886c256b5384a4218af069a23345be55ca7973378ca13a9155586f9c.jpeg",
    "https://cdn.faire.com/fastly/2d3aed44dbebac6a12963074b2118bbd54d6f8ce06a3691a1d90969dc81442dd.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "Upgrade your daily carry with this Women's Corduroy Tote Bags, a pair of spacious, stylish accessories that blend retro charm with practical functionality. Available in bold color, these totes let you switch up your look effortlessly¡ªperfect for work, shopping, or casual outings. Crafted from soft, textured corduroy, they have a warm, cozy vibe that feels both trendy and timeless.\n\nMaterial:\n\n * 100% Fabric\n",
  tags: [],
  msrpDollars: 24.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:18.471Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
